import { Image, Text } from "@chakra-ui/react";
import { MDBCol, MDBRow } from "mdbreact";
import React, { Component } from "react";
import man from "../../../asset/man.png";
import factory from "../../../asset/factory.png";
import mans from "../../../asset/mans.png";
import woman from "../../../asset/woman.png";
import "./service.css";
class RightPane extends Component {
  render() {
    return (
      <>
        <MDBRow>
          <MDBCol md="6">
            <Text className="title">Migrant remittances </Text>
            <p>
              You’re working abroad as a migrant and sending a share of your
              income home to your family, friends, or your own domestic bank
              account. You’re looking for cheap remittances with great reach in
              Africa, enabling you to either wire your money remittances to a
              bank account or enable its recipient to receive it in cash. This
              transaction could be a one-off, or on a regular basis.
            </p>
          </MDBCol>
          <MDBCol md="6">
            <Image src={woman} />
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol md="6">
            <Image src={man} />
          </MDBCol>
          <MDBCol md="6">
            <Text className="title"> Regular remittances:</Text>
            <p>
              You’re living abroad and want to conduct transactions to Africa on
              a regular basis; you are either sending your salary to your home
              bank account, transferring money from your home bank account to
              your current bank account or paying for something in installments
              (most commonly, mortgage payments and pensions).
            </p>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol md="6">
            <Text className="title"> Remitting payments: </Text>
            <p>
              Even if you have not moved abroad as an expat or migrant you may
              still have a bank account in Africa for a variety of reasons. If
              you are accepting money into that overseas bank account, you would
              eventually want to receive that money from abroad so you can make
              use of it. A remittance comparison should help you find the best
              solution.
            </p>
          </MDBCol>
          <MDBCol md="6">
            <Image src={mans} />
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol md="6">
            <Image src={factory} />
          </MDBCol>
          <MDBCol md="6">
            <Text className="title"> Business transactions :</Text>
            <p>
              You own a small or medium sized business and need to transfer
              money across country borders for paying suppliers, buying capital
              goods or paying remote working employees in different currencies.
              A decade ago, the first port of call for your company would have
              been your bank. With competition intensifying and MTOs now
              offering the same, and, in most instances, cheaper international
              money transfer services, you have far more options to choose from.
            </p>
          </MDBCol>
        </MDBRow>
      </>
    );
  }
}

export default RightPane;
